<era-pane>
  <h4 class="mt-auto small-caps">{{ headerTitle }}</h4>

  @if (showIdForm) {
    <form [formGroup]="form">
      <table class="table table-sm table-list mb-2">
        <thead>
          <tr>
            <th colspan="2"
                scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <!-- ID -->
          <tr>
            <th title="Name"
                data-toggle="tooltip"
                data-placement="right"
                scope="row">
              <label for="id"
                     class="col-form-label">Name</label>
            </th>
            <td>
              <input type="text"
                     class="form-control"
                     id="id"
                     formControlName="id" />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  }

  @switch (profileType) {
    @case ('airplay-security') {
      <ml-acp-airplay-ui [(airplayPreset)]="airplayPreset"
                         [allowToggle]="false"
                         [editingInput]="true"> </ml-acp-airplay-ui>
      <button type="button"
              class="btn btn-primary mb-3"
              (click)="savingPreset()">Save</button>
    }
    @case ('restrictions-profile') {
      <ml-mdm-restrictions-settings [(restrictionsProfile)]="restrictionsProfile"
                                    [allowToggle]="false"
                                    [editingInput]="true"
                                    title="Restrictions">
      </ml-mdm-restrictions-settings>
      <button type="button"
              class="btn btn-primary mb-3"
              (click)="savingPreset()">Save</button>
    }
    @case ('wifi-profile') {
      <ml-mdm-wifi-profile [(wifiProfile)]="wifiProfile"
                           [allowToggle]="false"
                           [editingInput]="true"
                           [showTitle]="false"
                           [showSubmitButton]="true"
                           (wifiProfileChanged)="savingPreset($event)"> </ml-mdm-wifi-profile>
    }
  }
</era-pane>